
import { Vue, Component, Watch } from "vue-property-decorator"
import MainSubCategorySearchForm from "@/components/Article/MainSubCategorySearchForm.vue"
import { mapActions } from "vuex"
import { SubCategory } from "types/subCategory"
import { DataTableHeader } from "vuetify/types"

type MainSubCategory = Pick<SubCategory["data"], "id" | "name" | "category">

@Component({
  components: { MainSubCategorySearchForm },
  methods: {
    ...mapActions("article", ["updateArticle"]),
  },
})
export default class SelectMainSubCategory extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "カテゴリー", value: "categoryName" },
      { text: "名前", value: "name" },
      { text: "選択", value: "select", sortable: false },
    ]
  }

  public dialog = false

  private mainSubCategories: MainSubCategory[] = []
  private loading = false
  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  public clear(): void {
    this.mainSubCategories = []
    this.resetPagination()
    const form = this.$refs.mainSubCategorySearchForm as InstanceType<
      typeof MainSubCategorySearchForm
    >
    form.reset()
  }

  public searchResult(result: MainSubCategory[], totalPages: number): void {
    this.mainSubCategories = result
    this.totalPages = totalPages
    this.loading = false
  }

  private close() {
    this.dialog = false
    this.clear()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    if (this.dialog) {
      this.loading = true
      const mainSubCategorySearchForm = this.$refs
        .mainSubCategorySearchForm as InstanceType<
        typeof MainSubCategorySearchForm
      >
      const page = this.pagination.page
      const sortBy = this.pagination.sortBy[0]
      const descending = this.pagination.sortDesc[0]
      mainSubCategorySearchForm.search(page, sortBy, descending)
      this.loading = false
    }
  }

  private select(mainSubCategory: MainSubCategory) {
    this.$store.dispatch("article/updateArticle", { mainSubCategory })
    this.close()
  }
}
